import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79e49261"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " Ihre eigene Solaranlage – für mehr Unabhängigkeit ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-xs-_" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Mit einer Solaranlage können Sie sich selbst mit erneuerbarer Energie versorgen. So werden Sie unabhängiger von den steigenden Energiepreisen, schonen Ihren Geldbeutel und schützen die Umwelt. ", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" JETZT ANGEBOT ANFORDERN ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://solar.htw-berlin.de/rechner/unabhaengigkeitsrechner/",
  target: "_blank"
}, " Solar Wirtschaftlichkeitsrechner ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Ein Angebot der Hochschule für Technik und Wirtschaft HTW Berlin - Angaben ohne Gewähr", -1))
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "solar-page-card" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " So funktioniert eine Photovoltaikanlage ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Eine der entscheidenden Komponenten bei der Energiegewinnung sind die Solarmodule. Bei Sonnenschein wandeln die Solarzellen, welche sich in den Solarmodulen befinden, das einfallende Licht in Gleichstrom um. Vom Wechselrichter wird dieser anschließend in netzkonformen Wechselstrom umgewandelt. Nun ist der Strom für Endverbraucher nutzbar. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Eine Photovoltaikanlage ist in ihrer Einrichtung komplex, aber in der Nutzung ganz einfach. Wir kümmern uns um die schwierigen Aspekte, damit Sie sich einfach darauf konzentrieren kannst, die selbst erzeugte Solarenergie zu genießen. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Wenn Sie Ihre PV-Anlage mit einem Stromspeicher kombinieren, profitieren Sie ganz besonders: Jeder Überschuss, der über den Tag gewonnen wird, wird für den späteren Bedarf gespeichert und kann somit auch nachts abgerufen werden. ")
], -1))
const _hoisted_12 = { class: "container" }

import { useStore } from 'vuex';
import PhotovoltaikStepsCard from '@/components/PhotovoltaikPage/PhotovoltaikStepsCard.vue';
import PhotovoltaikSupport from '@/components/PhotovoltaikPage/PhotovoltaikSupport.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhotovoltaikPageContent',
  setup(__props) {

const store = useStore();

const { ioappConfig } = window;
const backgroundImage = `url(${ioappConfig.pluginUri}public/img/photovoltaikAnlage.jpg)`;
const entryForm = () => store.dispatch('leadForm/entry');

return (_ctx: any,_cache: any) => {
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseSpacer, { size: "xl" }),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _createVNode(_component_BaseSpacer, { size: "l" }),
        _createVNode(_component_BaseButton, {
          color: "primary",
          class: "m-0",
          onClick: _withModifiers(entryForm, ["prevent"])
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_BaseSpacer),
        _createVNode(_component_BaseButton, {
          color: "primary",
          class: "m-0"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _hoisted_7
      ])
    ]),
    _createVNode(_component_BaseSpacer, { size: "xl" }),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_BaseSpacer),
          _hoisted_11,
          _createVNode(_component_BaseSpacer),
          _createElementVNode("div", {
            class: "card-image-bottom",
            style: _normalizeStyle({ backgroundImage: backgroundImage })
          }, null, 4)
        ])
      ])
    ]),
    _createVNode(_component_BaseSpacer, { size: "xl" }),
    _createVNode(PhotovoltaikStepsCard),
    _createVNode(_component_BaseSpacer, { size: "xl" }),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(PhotovoltaikSupport)
      ])
    ]),
    _createVNode(_component_BaseSpacer, { size: "xl" })
  ], 64))
}
}

})